import {observer, React} from '@api'
import {useShapeComponentStore} from '@modules/whiteboard'
import * as css from './OptionalShapeTitle.css'

export const OptionalShapeTitle = observer(function OptionalShapeTitle() {
  const store = useShapeComponentStore(),
    {optionalTitle, titleCssVars, onChangeOptionalTitle} = store

  if (!optionalTitle?.show) return null

  return (<div className={css.root} style={titleCssVars}>
    <input value={optionalTitle.title} placeholder='Title' onChange={onChangeOptionalTitle}/>
  </div>)
})


// WEBPACK FOOTER //
// ./src/modules/whiteboard/tools/OptionalShapeTitle.tsx